import { render, staticRenderFns } from "./ReceptionElectronicDocuments.vue?vue&type=template&id=7e6a619e"
import script from "./ReceptionElectronicDocuments.vue?vue&type=script&lang=js"
export * from "./ReceptionElectronicDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports